import {observable,action} from 'mobx';

class StationPermissionStore {
  @observable items = [];
  transportLayer;

  constructor(transportLayer) {
    this.transportLayer = transportLayer;
  }

  @action fetchUserParameterPermissions(id){
    this.transportLayer.fetchById(id).then(res => this.items = res);
  }
}

export default StationPermissionStore;



// WEBPACK FOOTER //
// ./src/stores/ParameterPermissionStore.js